import { render, staticRenderFns } from "./SinvoiceIndex.vue?vue&type=template&id=fcb3c7aa"
import script from "./SinvoiceIndex.vue?vue&type=script&lang=js"
export * from "./SinvoiceIndex.vue?vue&type=script&lang=js"
import style0 from "./SinvoiceIndex.vue?vue&type=style&index=0&id=fcb3c7aa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports